import type { app_role } from "supabase/types";
import { z } from "zod";
import { preferredLanguageSchema } from "~/schema";

export type UserProfileSchema = z.infer<typeof userProfileSchema>;
export const userProfileSchema = z.object({
  intent: z.literal("user:profile"),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: z.string().optional(),
  dateOfBirth: z.string().optional(),
  preferredLanguage: preferredLanguageSchema.optional(),
});

export type SignInSchema = z.infer<typeof signInSchema>;
export const signInSchema = z.union([
  z.object({
    intent: z.literal("sign_in:otp"),
    email: z.string().email(),
    code: z.string(),
    redirectTo: z.string().optional(),
  }),
  z.object({
    intent: z.literal("sign_in:email"),
    email: z.string().email(),
    token: z.string().optional(),
    redirectTo: z.string().optional(),
  }),
]);

export type SignUpSchema = z.infer<typeof signUpSchema>;
export const signUpSchema = z.union([
  z.object({
    intent: z.literal("sign_up:email"),
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
  }),
  z.object({
    intent: z.literal("sign_up:profile"),
    email: z.string().email(),
    phone: z.string(),
    firstName: z.string(),
    middleName: z.string().optional(),
    lastName: z.string(),
  }),
  z.object({
    intent: z.literal("sign_up:otp"),
    email: z.string().email(),
    code: z.string(),
  }),
]);

export type SignOutSchema = z.infer<typeof signOutSchema>;
export const signOutSchema = z.object({
  intent: z.literal("sign_out"),
});

export type SignUpInviteSchema = z.infer<typeof signUpInviteSchema>;
export const signUpInviteSchema = z.object({
  intent: z.literal("auth:invite"),
  email: z.string().email(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  role: z.enum(["org:agent", "org:staff", "org:owner", "org:admin"] as const satisfies app_role[]),
});

export type AuthTeamDeleteSchema = z.infer<typeof authTeamDeleteSchema>;
export const authTeamDeleteSchema = z.object({
  intent: z.literal("auth:team:delete"),
  user_id: z.string().uuid(),
});
